// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g1rGFyejYZSuBB {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.jaR3dzaovdTrTB {
  display: flex;
  justify-content: center;
}
.tpre71waW89D3R {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
._h5fxfNhwny2PJ {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.WgUeXIlJS9s3kg {
  font-style: italic;
}
.YrS_YtzTXSbEyz {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.DPTHsCRxEzbw_A {
  display: flex;
  align-items: center;
  justify-content: center;
}
.RxzI9t6tqZ9ypS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.RxzI9t6tqZ9ypS .ukqNYgqsmxK3q1 {
  margin: 12px 0 0;
}
.DSPDfxEBPvyUfj {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.DSPDfxEBPvyUfj button {
  margin-left: 8px;
}
.AkjKui4b9n7X_h {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .YrS_YtzTXSbEyz {
    padding: 16px;
  }
}
.HlMpKhDaXoKIzU label {
  display: block;
  margin-bottom: 4px;
}
.RGzSqCajPlD1Sv {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 8px;
}
.rKYXC8nXOkel1t {
  width: 36px;
  height: 36px;
  margin: 2px 0 0 10px;
  padding: 0;
}
.md2qYpZfeWQ3EX {
  flex-grow: 1;
  margin-top: 11px;
  margin-left: 45px;
}
.nDQ9TkeMfaELsT {
  margin-top: 0;
}
.DPTHsCRxEzbw_A {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .RGzSqCajPlD1Sv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .md2qYpZfeWQ3EX {
    max-width: 400px;
    margin-left: 0;
    color: var(--ds-text-subtle, #44546f);
  }
}
.NbIHRuAryg9Ve8 input {
  width: 320px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `g1rGFyejYZSuBB`,
	"flexAndCenter": `jaR3dzaovdTrTB`,
	"body": `tpre71waW89D3R`,
	"navigationAndContent": `_h5fxfNhwny2PJ`,
	"learnMoreSubtle": `WgUeXIlJS9s3kg`,
	"content": `YrS_YtzTXSbEyz`,
	"spinnerContainer": `DPTHsCRxEzbw_A`,
	"header": `RxzI9t6tqZ9ypS`,
	"title": `ukqNYgqsmxK3q1`,
	"footer": `DSPDfxEBPvyUfj`,
	"formFooter": `AkjKui4b9n7X_h`,
	"formElements": `HlMpKhDaXoKIzU`,
	"formSection": `RGzSqCajPlD1Sv`,
	"copyBtn": `rKYXC8nXOkel1t`,
	"inputDescription": `md2qYpZfeWQ3EX`,
	"label": `nDQ9TkeMfaELsT`,
	"textfield": `NbIHRuAryg9Ve8`
};
export default ___CSS_LOADER_EXPORT___;
